import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftScaleListItem = (props) => {
    const { scale, updateVisualizerSettings } = props;

    const onScaleChange = (value) => {
        updateVisualizerSettings({ drift: { scale: value } });
    };

    return (
        <SliderListItem
            title='Size'
            displayMultiplier={50}
            value={scale}
            min={0}
            max={100}
            step={1}
            onValueChange={onScaleChange}
            toolTip='How much the visualizer size increases during loud audio.'
        />
    );
};

const mapStateToProps = (state) => {
    const { scale } = state.createPreview.present.videoSettings.visualizer.drift;
    return { scale };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftScaleListItem);
